<template>
  <div id="app" class="pr" :class="{ overhidden: isShowMenu }" :style="{ background: bgColor }">
    <router-view />
  </div>
</template>

<script>
import $ from 'jquery'
import { $emit } from '@/utils/gogocodeTransfer'
// import { watermarkBlackList } from '@/utils/constant'
import event from '@/utils/event'
import isUniversity from '@/utils/isUniversityDomain.js'
import { getLocalStorage } from '@/utils/locatonStorge'
import { mapActions, mapMutations, mapState } from 'vuex'
import { isInApp } from './utils/device-detection'
import { getToken } from '@/utils/auth'
import { JSBridgeCall, addNativeEventListener, NativeBridgeEvents } from '@/utils/native-bridege'

export default {
  name: 'App',
  data() {
    return {
      isInApp,
      speed: 300000,
      headerShow: false,
      timer: null,
      isUniversity
    }
  },
  async created() {
    $(window).on('resize', e => {
      this.judgeIsMobile()
      this.navigateBoxWidth()
      this.modelNavigateHeight()
    })
    this.judgeIsMobile()
    this.getClientConfig()
    this.GetOperationData()
    // $(document).on('touchmove', e => {
    //   document.activeElement.blur()
    // })

    if (window.ChatglmOpenJSBridge?.registerNativeBack) {
      window.ChatglmOpenJSBridge.registerNativeBack((event, eventName, paramsString) => {
        console.log('ChatglmOpenJSBridge registerNativeBack: ' + eventName, paramsString)

        window.ChatglmOpenNativeBridge.calljs(eventName, paramsString)
      })
    }

    addNativeEventListener(
      NativeBridgeEvents.hostReady,
      data => {
        console.log('addNativeEventListener', data)
      },
      this
    )
    JSBridgeCall('jsBridgeReady')
  },
  computed: {
    ...mapState('Home', ['userInfo', 'isShowMenu', 'isMobile', 'showTryDialog', 'configuration']),
    bgColor() {
      const currentPath = this.$route.path.toLowerCase()
      if (currentPath.startsWith('/chat')) {
        if (this.isMobile) {
          return 'var(--bg_grey_1,#f6f7f9)'
        } else {
          return 'var(--bg_white_1,#ffffff)'
        }
      } else if (currentPath.startsWith('/detail')) {
        return 'var(--bg_grey_1,#f6f7f9)'
      } else {
        return 'var(--bg_white_1,#ffffff)'
      }
    }
  },
  methods: {
    ...mapMutations('Home', {
      setLeftTo: 'SET_LEFT_TO'
    }),
    ...mapActions('Home', [
      'GetUserInfo',
      'AgreeExperience',
      'GetOperationData',
      'getClientConfig'
    ]),
    changeTryDialogStatus() {
      const dialog = this.showTryDialog
      this.$store.commit('Home/SET_SHOWTRYDIALOG', !this.showTryDialog)
      if (dialog) {
        // 关闭弹框，即用户确认同意体验
        const { username } = this.userInfo || {}
        this.AgreeExperience({ username }).then(data => {
          // 弹出 “我们一直在路上信息”
          const type = this.isMobile ? '' : 'pc'
          $emit(event, 'operateNav', true, type)
        })
        if (isUniversity) {
          this.$router.push('detail')
        }
      }
    }
  },
  watch: {
    '$route.path': function (path) {
      // add by yangcj,support electron
      console.log(`$route.path---------> ${path}`)
      if (window.electronAPI?.updateDocWorkingStatus) {
        window.electronAPI.updateDocWorkingStatus(false)
      }
      if (window.electronAPI?.registerToolbarEx) {
        window.electronAPI.registerToolbarEx((event, value) => {
          console.log('watched path tool -------------------->: ' + path)
          if (path !== '/main/detail' || path !== '/main/alltoolsdetail') {
            console.log('watched path need jump-------------------->: ' + path)

            if (getLocalStorage('chatTools') === 'glm-4') {
              this.$router.push({
                name: 'alltoolsdetail',
                state: { params: { gettext: value } }
              })
            } else {
              this.$router.push({
                name: 'Detail',
                state: { params: { gettext: value } }
              })
            }
          }
        })
      }
    },
    $route(to, from) {
      if (from.name === 'Detail' && to.name === 'alltoolsdetail') {
        this.setLeftTo('left-right')
      } else if (from.name === 'alltoolsdetail' && to.name === 'Detail') {
        this.setLeftTo('right-left')
      } else {
        this.setLeftTo('')
      }
    },
    userInfo(val) {
      if (window.electronAPI?.loginReady) {
        window.electronAPI.loginReady(Boolean(val?.phone?.length > 0))
      }

      // 向主进程推送用户信息
      JSBridgeCall('jsUpdateUserInfo', val)

      if (!val) {
        return
      }

      // console.log('测试这里时候输出----', val)
      /**
       * 此处监听用户信息变化：
       * 1.监听是否已实名认证
       * 2.监听是否是已同意体验
       * */
      // // console.log('测试这里时候输出----', val.real_name_identify)
      // if (val.real_name_identify) {
      //   console.log('已实名认证', val)
      //   if (!val.agree_experience) {
      //     // 已实名认证，但未同意体验
      //     this.tryDialog = true
      //   }
      // } else {
      //   this.realNameDialog = true
      // }
      if (!val.agree_experience && !isUniversity) {
        // 已实名认证，但未同意体验(非校园域名用户)
        // this.$store.commit('Home/SET_SHOWTRYDIALOG', true)
      }
    }
  },
  mounted() {
    getToken() && this.GetUserInfo({ forceUpdate: true })
    this.sendPv({
      md: 'ratio',
      ct: window.screen.width + '*' + window.screen.height
    })
  },
  emits: ['operateNav']
}
</script>

<style lang="less">
.el-message__content {
  word-break: break-all;
}
html {
  min-height: @screen-min-height;
  overflow: auto;
  background: var(--chat_box_shadow_1, #fff);
  body {
    min-height: @screen-min-height;
    #app {
      height: 100%;
      // min-width: 768px;
      overflow: auto;
      // overflow-x: hidden;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      font-size: 14px;
      min-height: @screen-min-height;
      .real_name_dialog {
        display: flex;

        .el-dialog {
          border-radius: 8px;
          margin: auto !important;
        }
      }
    }
  }
}
html > body {
  overflow: hidden;
}

#digital_manual {
  width: 10%;
  height: 13.75%;
  position: absolute;
  left: 28%;
  top: 10%;
  object-fit: cover;
}

.detail-container {
  background: var(--bg_grey_1, #131314);
  transition: background-color 0.3s;
  min-height: @screen-min-height;
  min-width: 442px;
  position: relative;
  &.white {
    background-color: var(--bg_white_1, #fff) !important;
  }
  .glm-4-conversation-gap {
    padding: 0 36px;
    //margin-top: 13px;
  }
  @media (max-width: 500px) {
    .glm-4-conversation-gap {
      padding: 0 20px;
    }
  }
  // 设置小屏幕是欢迎页样式
  .mini-screen {
    .init-page.pc {
      .wrap {
        .content {
          min-width: 372px;
          .title-container {
            padding: 0 8px;
          }
          .actions-container {
            width: 100%;
            .page-welcome-content-container {
              .mix-layout-container.mix {
                position: relative;
                .mix-zone-left {
                  align-items: center;
                  .text-item-container.mix-item {
                    width: 100%;
                    max-width: 100%;
                  }
                }
                .mix-zone-right {
                  // 此处不用display none 是为了避免切换中出现轮播图缩小且不变换的情况
                  opacity: 0;
                  position: absolute;
                  z-index: -10;
                }
              }
              .mix-layout-container.mix2 {
                .mix2-card-wrapper {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
.search-container .search-box-container,
.search-container-glm3 {
  border-radius: 12px;
  z-index: 999;
  border: 1px solid var(--bg_lable_grey_2, #545459);
  background: var(--bg_chat_box_grey_1, #434346);
  .input-box {
    border-radius: 12px;
  }
  &:focus-within {
    box-shadow: 0px 4px 12px 0px #11315f14;
    border: 1px solid var(--txt_icon_grey_4, rgba(26, 32, 41, 0.4));
  }
}

.no-border {
  border: none !important;
}

.markdown-body {
  // overflow: hidden;
  position: relative;

  .loadingGif + p {
    display: inline;
    /* 如果紧邻的兄弟元素是特定类的 <div>，则恢复同一行显示 */
  }

  /* 后面跟着loadingGif类的p元素不换行 */
  p:has(+ .loadingGif) {
    display: inline;
  }

  span.newsIndex {
    border-radius: 4px;
    background: #efefef;
    margin: 0 4px;
    padding: 0px 3px;
    font-size: 12px;
    display: inline-block;
    min-width: 14px;
    line-height: 14px;
    transform: translateY(-1px);
    text-align: center;

    &:hover {
      cursor: pointer;
      background: rgba(36, 84, 255, 0.1);
      color: #2454ff;
    }
  }

  li > p {
    display: inline;
  }

  .top {
    background-color: rgba(62, 111, 251, 0.1);
    position: relative;
    height: 10px;

    .copy-button {
      position: absolute;
      right: 10px;
      display: flex;
      padding: 2px 8px;
      justify-content: center;
      align-items: center;
      gap: 2px;
      border-radius: 6px;
      background: var(--bg_chat_white_2, rgba(30, 31, 32, 0.9));
      color: var(--txt_icon_black_1, rgba(255, 255, 255, 0.95));
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      &:hover {
        color: var(--blue, #2454ff);
        cursor: pointer;
      }
    }
  }
}

.detail {
  position: relative;

  &.drag-over * {
    pointer-events: none;
  }

  .drag-over {
    position: absolute;
    height: calc(100% - 24px);
    width: calc(100% - 24px);
    flex: none;
    z-index: 1000;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px dashed #2554ff;
    padding: 0;
    margin: 12px 12px;
    background: #f6f9ff;

    .drag-icon-wrap {
      padding-top: 83px;
    }

    .drag-title {
      padding-top: 16px;
      margin-bottom: 83px;
    }

    &::after {
      content: '';
      position: absolute;
      display: block;
      width: 157px;
      height: 96px;
      background-size: cover;
      background-image: url('~@/assets/image/upload/uploadIcon.png');
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1001;
    }

    &.drag-over-code::after {
      background-image: url('~@/assets/image/upload/uploadIconCode.png');
    }
    &.drag-over-code-glm4::after {
      width: 217px;
      height: 124px;
      background-image: url('~@/assets/image/upload/uploadIconCode2.png');
    }
  }

  .markdown-body pre {
    background-color: @code-bgColor;
  }

  .footer {
    button {
      &:hover {
        color: #3e6ffb;
        border: 1px solid #3e6ffb;

        &::before {
          background-image: url(~@/assets/svg/down_load_on.svg);
        }
      }

      &::before {
        display: block;
        content: '';
        width: 20px;
        height: 20px;
        background-image: url(~@/assets/svg/down_load.svg);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 70%;
      }
    }
  }
}

.markdown-body {
  font-size: 15px;
  line-height: 27px;

  p {
    margin-bottom: 14px;
  }

  li > p {
    margin-top: 6px;
    margin-bottom: 6px;
  }
}

.detail {
  display: flex;
  justify-content: center;
  align-self: flex-start;
  flex: auto;
  // height: calc(100vh - 80px - 268px);
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0 auto;
  // background-color: #f6f7f9;
  // background: var(--bg_white_1, #fff);
  height: 100%;
  flex: auto;

  .session-block {
    // width: calc(100% - @sessionListAndSideWidth);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // height: calc(100vh - 80px);
    // margin-left: @sessionListAndSideWidth;
    //padding-top: 13px;
    // padding-bottom: 10px;
    overflow: scroll;
    // background: var(--bg_white_1, #fff);
    box-sizing: border-box;
    // box-sizing: content-box;

    .last-div {
      height: 47px;
      background: transparent;
      line-height: 47px;
    }

    &.no-padding-top {
      padding-top: 0;
    }
  }

  .item {
    margin: 0 auto;
    max-width: 800px;
    min-width: 371px;
    padding: 0 36px;
    box-sizing: border-box;
    width: 100%;

    .question-image-type {
      margin-left: 12px;

      &.image-with-text {
        margin-bottom: 12px;
      }

      .upload_wrap {
        width: 256px;
        height: 256px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        .img-loading {
          border-radius: 8px;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  @media (max-width: 900px) {
    .item {
      padding: 0 20px;
    }
  }

  // .translateX {
  // transform: translateX(-30px);
  // }

  .search-box {
    padding-bottom: 12px;
    box-sizing: border-box;
    align-self: flex-end;
    width: 100%;
    padding-top: 20px;
    // background: var(--bg_white_1, #fff);
    &.panelState_0 {
      --prompt-side-width: 70px;
    }

    &.panelState_1 {
      --prompt-side-width: 326px;
    }

    &.panelState_2 {
      --prompt-side-width: 500px;
    }

    & > div {
      background: transparent !important;
    }

    .component-box {
      max-width: 872px;
      min-width: @input-min-width;
      padding: 0 36px;
      box-sizing: border-box;
      margin: 0 auto;
    }
    @media (max-width: 500px) {
      .component-box {
        padding: 0 20px;
      }
    }

    .footer {
      position: static;
      box-sizing: border-box;
    }
  }

  .latest-news {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .line-left {
      flex: 1;
      height: 1px;
      background: linear-gradient(270deg, #2454ff 0%, rgba(36, 84, 255, 0) 100.69%);
    }

    .line-right {
      flex: 1;
      height: 1px;
      background: linear-gradient(270deg, #2454ff 0%, rgba(36, 84, 255, 0) 100.69%);
      transform: matrix(-1, 0, 0, 1, 0, 0);
    }

    .latest-news-content {
      padding: 28px 20px;

      span {
        font-weight: 400;
        font-size: 15px;
        line-height: 25px;
        text-align: center;
        color: #4f5866;
      }
    }
  }

  .item {
    .interval-time {
      margin-bottom: 15px;
      margin-top: 15px;
      color: #666666;
    }

    &:last-child {
      .answer {
        .panel {
          margin-bottom: 0;
        }
      }
    }

    .answer {
      background: transparent;
      border-radius: 8px;
      position: relative;
      overflow: visible;
      font-size: 15px;
      line-height: 27px;

      .panel {
        // background: #ffffff;
        border-radius: 8px;
        padding: 0 12px 20px 12px;

        // .answer-loading {
        // margin-bottom: -8px;
        // }

        .printing {
          margin-bottom: 10px;
          overflow: hidden;
        }
      }
      @media (max-width: 900px) {
        .panel {
          padding: 0 0 20px;
        }
      }

      .collectionGuide {
        background-image: url(~@/assets/image/collectionGuide.gif);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: 103px;
        width: 206px;
        position: absolute;
        left: -93px;
        bottom: 22px;
      }

      .shareGuide {
        background-image: url(~@/assets/image/shareGuide.gif);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: 103px;
        width: 205px;
        position: absolute;
        right: 0px;
        bottom: 80px;
      }

      .shareGuideImg {
        background-image: url(~@/assets/image/shareGuideImg.gif);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: 103px;
        width: 205px;
        position: absolute;
        right: 0px;
        bottom: 80px;
      }

      .robot-img {
        height: 32px;

        img {
          width: 32px;
          height: 32px;
        }
      }

      .robotIcon {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        .glmsChatAvatar {
          width: 24px;
          height: 24px;
          border-radius: 16px;
          background-size: cover;
          background-repeat: no-repeat;
          background-image: url('~@/assets/image/robot_img_new.png');
          background-color: #eff1f4;
        }

        .robotEmerge {
          width: 30px;
          height: 30px;
          background-image: url('~@/assets/image/pc_20speed-min.gif');
          background-size: cover;
          background-repeat: no-repeat;
          animation: imageEmergeAnimation 0.4s forwards;
          &.robotEmerge-dark {
            background-image: url('~@/assets/image/pc_20speed-min-dark.webp');
            background-size: cover;
            background-repeat: no-repeat;
            animation: imageEmergeAnimation 0.4s forwards;
          }
        }

        @keyframes imageEmergeAnimation {
          0% {
            transform: scale(1);
          }

          100% {
            transform: scale(0.8);
            background-image: url('~@/assets/image/robot_img_new.png');
          }
        }

        .loadingIcon {
          width: 24px;
          height: 24px;
          background-image: url('~@/assets/image/loadingIcon.png');
          background-size: cover;
          background-repeat: no-repeat;
          animation: imageAnimation 0.4s linear forwards;
        }
        .loadingIcon-dark {
          width: 24px;
          height: 24px;
          background-image: url('~@/assets/image/loadingIcon.png');
          background-size: cover;
          background-repeat: no-repeat;
          animation: imageAnimationDark 0.4s linear forwards;
        }
        @keyframes imageAnimation {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.25);
            background-image: url('~@/assets/image/pc_20speed-min.gif');
          }
        }
        @keyframes imageAnimationDark {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.25);
            background-image: url('~@/assets/image/pc_20speed-min-dark.webp');
          }
        }
      }

      .error-box {
        text-align: left;
        color: var(--txt_icon_grey_6, #b0b7c0);
      }

      .loading {
        height: 24px;
      }

      .code-box {
        padding-left: 8px;
        margin-top: 3px;
        // overflow: hidden;

        &.error {
          margin-top: 0;
        }
      }

      pre {
        code {
          line-height: 1.6;
        }
      }

      .interact {
        // padding-right: 5px;
        margin-left: 8px;
        display: flex;
        // flex-direction: row-reverse;
        animation: interactEmergeAnimation 0.6s forwards;
        user-select: none;

        @keyframes interactEmergeAnimation {
          0% {
            opacity: 0;
          }

          100% {
            opacity: 1;
          }
        }

        .tip {
          flex: 1;

          span {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: #b0b7c0;
          }

          text-align: left;
        }

        .interact-operate {
          // width: 210px;
          display: flex;
          flex-direction: row;
          margin-top: -8px;

          .collected {
            position: relative;
            background-image: url(~@/assets/image/collection_clicked.png);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            width: 20px;
            height: 20px;

            &:hover {
              background-image: url(~@/assets/image/collection_clicked_hover.png);
            }
          }

          .uncollected {
            position: relative;
            background-image: url(~@/assets/svg/collection.svg);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            width: 20px;
            height: 20px;

            &:hover {
              background-image: url(~@/assets/image/collection_hover.png);
            }
          }
          .grey {
            background-image: url(~@/assets/image/collection_hover.png);
          }
          .uncollected-dark {
            background-image: url(~@/assets/svg/collection-dark.svg);
            position: relative;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            width: 20px;
            height: 20px;
          }
        }

        .nanual-retry {
          display: flex;
          flex-direction: row;
          position: absolute;
          right: 16px;
          bottom: -33px;

          &:hover {
            cursor: pointer;
          }

          .nanual-retry-image {
            padding-top: 4px;

            img {
              width: 20px;
              height: 20px;
            }
          }

          .nanual-retry-text {
            padding-left: 6px;

            span {
              font-family: 'PingFang SC';
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 22px;
              color: var(--txt_icon_black_1, #1a2029);
            }
          }
        }

        .reverse {
          transform: rotate(180deg);
        }

        .shim {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          // margin-left: 10px;
          cursor: pointer;
          color: #999;
          font-size: 16px;
          text-align: center;
          line-height: 20px;
          border: 1px solid transparent;
          border-radius: 8px;
          padding: 8px;

          img {
            width: 20px;
            height: 20px;
          }

          &.thumbs-selecting {
            background: rgba(26, 32, 41, 0.06);
          }

          &:hover {
            background: var(--hover_icon_grey_1, #434346);
          }

          &.copy {
            width: 20px;

            img {
              padding-right: 3px;
            }

            span {
              font-family: 'PingFang SC';
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 16px;
              color: #838a95;
              position: relative;
              top: -4px;
            }
          }

          &.share {
            img {
              width: 20px;
              height: 20px;
              padding-right: 3px;
            }

            span {
              color: #838a95;
              font-size: 14px;
              font-family: PingFang SC;
              font-style: normal;
              font-weight: 400;
              line-height: 16px;
              position: relative;
              top: -4px;
            }
          }
        }

        .thumbs-down-on,
        .thumbs-up-on {
          // border: 1px solid #3485ff;
          color: #1679ff;
        }

        .thumbs-down-on {
          position: relative;
        }

        @keyframes hideReport {
          to {
            visibility: hidden;
          }
        }

        .report_block {
          position: absolute;
          z-index: 2;
          width: 36px;
          top: 30px;
          font-size: 12px;
          padding: 5px 5px;
          line-height: 12px;
          background-color: #979797;
          color: #fff;
          border-radius: 4px;
          left: -27%;
          animation: hideReport 3s forwards;

          &::before {
            content: '';
            width: 4px;
            height: 4px;
            position: absolute;
            background-color: #979797;
            top: -2px;
            left: 47%;
            transform: rotate(45deg);
          }
        }
      }
    }

    .question {
      // background-color: #fff;
      // border-radius: 6px;
      // box-sizing: border-box;
      // padding-left: 20px;
      // padding-right: 20px;
      // padding-top: 24px;
      // padding-bottom: 20px;
      padding: 0 12px 20px;
      position: relative;

      .image-with-text {
        margin-top: 12px;
      }

      .unCheckedStatusBtn {
        position: absolute;
        background-image: url(~@/assets/image/unclicked.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: 16px;
        width: 16px;
        left: -18px;
        transform: translateY(8px);

        &:hover,
        &:active {
          background-image: url(~@/assets/image/unclick_hover.png);
          cursor: pointer;
        }
      }

      .checkboxDisabled {
        background-image: url(~@/assets/image/checkboxDisabled.png);
        position: absolute;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: 16px;
        width: 16px;
        left: -18px;
        transform: translateY(8px);
      }

      .onCheckedStatusBtn {
        background-image: url(~@/assets/image/onclicked.png);
        position: absolute;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        height: 16px;
        width: 16px;
        left: -18px;
        transform: translateY(8px);

        &:hover,
        &:active {
          background-image: url(~@/assets/image/onclick_hover.png);
          cursor: pointer;
        }
      }

      .question-txt {
        padding-top: 0px;
        padding-bottom: 5px;
        padding-left: 7px;
        margin-left: 5px;
        padding-right: 5px;
        // margin-right: -20px;
        position: relative;
        cursor: pointer;

        &:hover {
          background: rgba(74, 90, 112, 0.06);
          border-radius: 8px;
        }

        span {
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 27px;
          color: var(--txt_icon_black_1, #1a2029);
        }
      }

      .expand {
        cursor: pointer;
        position: absolute;
        right: 0px;
        bottom: 0px;
        font-size: 12px;
        width: 80px;
        height: 30px;
        background: linear-gradient(
          270deg,
          var(--bg_grey_1, #f6f7f9) 63.08%,
          rgba(246, 247, 249, 0) 100%
        );
        text-align: right;
        padding-bottom: 4px;
        padding-top: 4px;

        span {
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 400;
          font-size: 15px;
          line-height: 27px;
          color: #2454ff;
        }
      }

      .user-img {
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-left: 4px;
      }

      input {
        display: none;
      }

      input {
        color: #333;
        outline: none;
        height: 30px;
        border: none;
        font-size: 16px;
        margin: 13px 20px;
        flex: 1;
      }

      .copy_btn {
        position: absolute;
        top: 20px;
        right: -24px;
      }

      &:hover {
        .edit-copy {
          cursor: pointer;
          visibility: visible;
        }
      }

      .edit-copy {
        visibility: hidden;
        // width: 20px;
        // height: 20px;
        padding: 7px 8px;
        border-radius: 8px;

        img {
          width: 20px;
          height: 20px;
        }

        &:hover {
          background: rgba(79, 88, 102, 0.08);
        }

        &.canuse {
          &:hover {
            color: #3485ff;
          }
        }
      }

      transition: border 1s ease;
    }
    @media (max-width: 900px) {
      .question {
        padding: 0 0 20px;
      }
    }

    .question-image {
      // margin-bottom: 20px;
      margin-left: 12px;

      &.question-image-upload {
        margin-top: 0px;
      }
    }

    .question-file {
      display: flex;
      width: 260px;
      padding: 8px;
      align-items: center;
      gap: 8px;
      border-radius: 8px;
      background: #fff;
      margin-left: 12px;
      transform: translateY(-10px);

      /*       &:hover {
        cursor: pointer;
        border-radius: 8px;
        border: 1px solid #2454ff;
        padding: 7px;
        background: rgba(36, 84, 255, 0.08);
        .file-name {
          color: #2454ff;
        }
      } */
      .file-icon {
        flex: 0 0 36px;
        width: 36px;
        height: 36px;
        background-image: url(~@/assets/image/file-icon.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .file-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        flex: 1 0 0;
        overflow: hidden;
        color: var(--txt_icon_black_1, #1a2029);
        text-overflow: ellipsis;
        font-family: PingFang SC;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        /* 180% */
        text-align: left;
      }
    }
  }

  @keyframes image-upload {
    0% {
      transform: rotate(0);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
[v-cloak] {
  display: none;
}

.search-container {
  position: relative;
}

highlight-input {
  caret-color: rgb(36, 84, 255);
}

highlight-input::selection {
  color: #4f5866;
  background: none;
}

.prosemirror-editor {
  box-sizing: border-box;
  padding: 1px;
  max-height: 262px;
  width: 100%;
  outline: none;
  color: var(--txt_icon_black_1, #1a2029);
  text-align: left;
  font-size: 15px;
  line-height: 27px;
  overflow-y: auto;
  word-break: break-word;
  caret-color: #2454ff;

  span {
    font-size: 15px;
    white-space: pre-wrap;
    word-break: break-word;
    outline: none;
    background: none !important;
    background: var(--bg_floating_white_1, #363739) !important;
    &.bpo-text {
      color: var(--txt_icon_black_1, #1a2029);
      background: var(--angent_special_grey_3, #2f3031) !important;
      font-weight: 700;
    }
    &:nth-child(even) {
      background: none !important;
    }
    &.bpo-text-common {
      animation: bpoFadeOut 1s linear;
    }
    &:hover {
      background: var(--angent_special_grey_3, #2f3031) !important;
    }
  }

  span:hover {
    highlight-input {
      color: var(--txt_icon_black_1, #1a2029);
      border-radius: 4px;
      background: none !important;
    }
  }
  .hover-highlight-input:hover {
    highlight-input {
      color: var(--txt_icon_black_1, #1a2029);
      border-radius: 4px;
      background: transparent !important;
    }
  }

  span::selection {
    color: var(--txt_icon_black_1, #1a2029);
    background: var(--bg_idea_blue_1, #2f3031);
  }

  p::selection {
    color: var(--txt_icon_black_1, #1a2029);
    background: var(--bg_idea_blue_1, #2f3031);
  }

  .highlight-input {
    border-radius: 4px;
    background: transparent !important;
    color: var(--txt_icon_black_1, #1a2029) !important;
  }

  .highlight-input::selection {
    color: var(--txt_icon_black_1, #1a2029);
    background-color: var(--bg_idea_blue_1, #2f3031) !important;
  }

  div::selection {
    color: var(--txt_icon_black_1, #1a2029);
    background: var(--bg_idea_blue_1, #2f3031);
  }

  .ProseMirror {
    display: block;
    width: 100%;
    height: 60px;
    outline: none;
  }

  p {
    outline: none;
    padding-bottom: 12px;
  }

  &:only-child > p:first-child:last-child {
    padding-bottom: 0px;
  }
}

.prosemirror-editor::selection {
  color: var(--txt_icon_black_1, #1a2029);
  background: var(--bg_idea_blue_1, #2f3031);
}

.search-container {
  .mouse-effect.on,
  .mouse-effect:hover {
    .input-box {
      padding: 10px 10px 10px 20px;

      textarea {
        height: 25px;
        margin: 0;
        caret-color: #2454ff;
      }

      .close {
        margin-top: 2px;
      }

      .enter-btn {
        width: 61px;
        height: 61px;
        color: #3e6ffb;
        border-radius: 8px;
        font-size: 20px;

        .chatglm_logo_white {
          display: block;
        }
      }
    }
  }

  .no-effect {
    #search-input-box {
      padding: 12px 16px;

      textarea {
        height: 29px;
        caret-color: #2454ff;
        margin: 0;
      }

      .close {
        margin-top: 2px;
      }

      .enter-btn {
        width: 61px;
        height: 61px;
        border-radius: 8px;
      }

      // &:hover {
      //   border: 1px solid #838a95;
      //   border: 1px solid #d3d7dd;
      // }
    }
  }
}

@keyframes bpoFadeOut {
  0% {
    background: #e5efff !important;
    // font-weight: 700;
  }

  100% {
    background: transparent !important;
    // font-weight: 400;
  }
}

.background_color_white {
  background-color: #fff !important;
}

.stop-answer-default {
  color: #838a95;
  user-select: none;
}
.cloud-sync-dialog {
  min-width: 325px;
}
</style>
